// @flow

import ForgottenPassword from "./ForgottenPassword";

export default ForgottenPassword;
